import { render, staticRenderFns } from "./CreateThreadPage.vue?vue&type=template&id=d0cca932&scoped=true"
import script from "./CreateThreadPage.vue?vue&type=script&lang=js"
export * from "./CreateThreadPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cca932",
  null
  
)

export default component.exports